import { z } from 'zod';

import { defineInvisible } from '@apps/web/features/phoebe_chat_v3/registry/types';

const jsonObjectSchema = z.record(z.string(), z.json());

const automationRunSourceEventSchema = z
    .object({
        id: z.uuid(),
        name: z.string(),
        entity_type: z.string(),
        entity_id: z.uuid(),
        occurred_at: z.iso.datetime({ offset: true }),
        data: jsonObjectSchema.optional(),
    })
    .strip();

const automationRunRequestedPayloadSchema = z
    .object({
        type: z.literal('automation_run_requested').optional(),
        automation_id: z.uuid(),
        automation_run_id: z.uuid(),
        automation_name: z.string(),
        fire_reason: z.enum(['scheduled', 'manual', 'event']),
        instructions: z.string(),
        tool_policy: z.string(),
        schedule_snapshot: jsonObjectSchema.nullable().optional(),
        source_event: automationRunSourceEventSchema.nullable().optional(),
        references: z.array(jsonObjectSchema).optional(),
    })
    .strip();

export const automationRunRequestedDefinitions = {
    automation_run_requested: defineInvisible('automation_run_requested', {
        disposition: 'invisible',
        schema: automationRunRequestedPayloadSchema,
        malformed: { kind: 'skip' },
        evidence: null,
    }),
} as const;

export const automationRunRequestedContractFixtures = {
    valid: {
        type: 'automation_run_requested',
        automation_id: '00000000-0000-4000-8000-000000000001',
        automation_run_id: '00000000-0000-4000-8000-000000000002',
        automation_name: 'Internal automation name',
        fire_reason: 'event',
        instructions: 'Internal automation instructions',
        tool_policy: 'internal-policy',
        schedule_snapshot: { cadence: 'daily' },
        source_event: {
            id: '00000000-0000-4000-8000-000000000003',
            name: 'internal-source-event',
            entity_type: 'shift',
            entity_id: '00000000-0000-4000-8000-000000000004',
            occurred_at: '2026-08-28T12:00:00Z',
            data: { source: 'internal' },
        },
        references: [{ source: 'internal' }],
    },
    malformed: {
        type: 'automation_run_requested',
        automation_id: 'not-a-uuid',
        automation_run_id: '00000000-0000-4000-8000-000000000002',
        automation_name: 'Internal automation name',
        fire_reason: 'event',
        instructions: 'Internal automation instructions',
        tool_policy: 'internal-policy',
    },
} as const;
